import React from 'react'

export default function MinusSvg() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={15}
            height={15}
            viewBox="0 -12 32 32"
        >
            <title>{"minus"}</title>
            <path
                fill="#000"
                fillRule="evenodd"
                d="M28 0H4a4 4 0 1 0 0 8h24a4 4 0 1 0 0-8"
            />
        </svg>
    )
}
